import React from "react";
import { Link } from "react-router-dom";
import { Link as Link1 } from "react-scroll";
import {
  AiFillLinkedin,
  BiLogoFacebook,
  AiOutlineInstagram,
  FiMail,
} from "../../assets/icons/vander";
import "./Footer.scss";
import logo from "../../assets/images/logos/aduppankarailogo-whitebg.jpg";

export default function Footer() {
  return (
    <footer className="footer-section">
      {/* Footer Main Content */}
      <div className="footer-main">
        <div className="container">
          <div className="row">
            {/* About Section */}

            {/* Links */}
            <div className="col-lg-4 col-md-4 col-6">
              <h5 className="footer-head">Useful Links</h5>
              <ul className="footer-links">
                <li>
                  <Link1
                    to={"about"}
                    spy
                    smooth
                    duration={500}
                    className="nav-item cursor-pointer"
                  >
                    About Us
                  </Link1>
                </li>
                <li>
                  <Link1
                    to={"menus"}
                    spy
                    smooth
                    duration={500}
                    className="nav-item cursor-pointer"
                  >
                    Menus
                  </Link1>
                </li>
                <li>
                  <Link1
                    to={"tables"}
                    spy
                    smooth
                    duration={500}
                    className="nav-item cursor-pointer"
                  >
                    Tables
                  </Link1>
                </li>
                <li>
                  <Link1
                    to={"contact"}
                    spy
                    smooth
                    duration={500}
                    className="nav-item cursor-pointer"
                  >
                    Contact Us
                  </Link1>
                </li>
              </ul>
            </div>

            <div className="col-lg-4 col-md-4 col-12 mb-4">
              <h5 className="footer-head">Open Hours</h5>
              <ul className="footer-links">
                <li>Monday - Friday: 10 AM - 11 PM</li>
                <li>Saturday - Sunday: 9 AM - 1 PM</li>
              </ul>
              <div className="col-lg-3 col-12 mb-4">
                <ul className="footer-social-icons">
                  <li>
                    <Link
                      target="_blank"
                      rel="noopener noreferrer"
                      to="https://www.linkedin.com/showcase/aduppankarai/"
                    >
                      <AiFillLinkedin />
                    </Link>
                  </li>
                  <li>
                    <Link
                      target="_blank"
                      rel="noopener noreferrer"
                      to="https://www.facebook.com/profile.php?id=61578160061472"
                    >
                      <BiLogoFacebook />
                    </Link>
                  </li>
                  <li>
                    <Link
                      target="_blank"
                      rel="noopener noreferrer"
                      to="https://www.instagram.com/_aduppankarai/?hl=en"
                    >
                      <AiOutlineInstagram />
                    </Link>
                  </li>
                  <li>
                    <Link
                      target="_blank"
                      rel="noopener noreferrer"
                      to="mailto:info@aduppankarai.com"
                    >
                      <FiMail />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-6">
              <h5 className="footer-head">Powered By</h5>
              <img
                className="powered-by-img rounded-4 bg-white"
                style={{ objectFit: "contain", padding: "5px" }}
                src={logo}
                alt="Aduppankarai Logo"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom Bar */}
      <div className="footer-bottom">
        <div className="container text-center">
          <p>
            © {new Date().getFullYear()} - Alize Software Services LLP - All
            rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
}
